var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"favorited_button",class:{liked: _vm.favoritedItem.favorited},on:{"click":function($event){$event.stopPropagation();return _vm.onClickFavorited.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }